/* eslint-disable import/prefer-default-export */
import API from 'utils/api';
import { onError } from 'utils/handlers';
import { SET_ACTUACIONES_PAE, SET_ESTADOS_DE_CREDITOS_PAE } from 'store/reducers/catalogs';
import { store } from 'store';

/*
  actuaciones: Object[]
  {
    "id": number,
    "descripcion": string,
    "actuacion_inicial": boolean,
    "actuacion_final": boolean,
    "uso_interno": boolean,
    "orden_de_uso_presentacion": number | null,
    "estados_globales": number
  }
*/

/**
 * GET Estados del Credito
 * param {object} params
 * @returns {Promise<{actuaciones: object[]}>}
 */
export const getActuacionesPae = async (params) => {
  try {
    const { actuacionesPae } = store.getState().catalogs;
    if (actuacionesPae?.length) return actuacionesPae;

    const response = await API.get('recaudacion/actuaciones-pae/', { params });
    store.dispatch({
      type: SET_ACTUACIONES_PAE,
      payload: response.data,
    });
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};

// export const getEstadosDeEjecucion = async (params) => {
//   try {
//     const response = await API.get('recaudacion/estados-de-ejecucion-pae/', { params });
//     return response.data;
//   } catch (err) {
//     onError(err);
//     return [];
//   }
// };

export const loadActuacionesPae = async () => {
  try {
    const ACTUACIONES_PAE = [
      {
        id: 1,
        descripcion: 'Generado',
        estados_globales: 1,
      },
      {
        id: 2,
        descripcion: 'Invitacion',
        estados_globales: 1,
      },
      {
        id: 3,
        descripcion: 'Otro',
        estados_globales: 1,
      },
      {
        id: 4,
        descripcion: 'Inicio PAE',
        estados_globales: 1,
      },
      {
        id: 5,
        descripcion: 'Notificacion PAE',
        estados_globales: 1,
      },
      {
        id: 6,
        descripcion: 'Embargo PAE',
        estados_globales: 1,
      },
      {
        id: 7,
        descripcion: 'Remate PAE',
        estados_globales: 1,
      },
      {
        id: 8,
        descripcion: 'Otro PAE',
        estados_globales: 1,
      },
      {
        id: 9,
        descripcion: 'Concluido PAE',
        estados_globales: 1,
      },
      {
        id: 10,
        descripcion: 'Pago',
        estados_globales: 1,
      },
      {
        id: 11,
        descripcion: 'Pago_Abonado',
        estados_globales: 1,
      },
      {
        id: 12,
        descripcion: 'Pago_Saldado',
        estados_globales: 1,
      },
      {
        id: 13,
        descripcion: 'Cancelo_Pago',
        estados_globales: 1,
      },
      {
        id: 14,
        descripcion: 'Litigio',
        estados_globales: 1,
      },
      {
        id: 15,
        descripcion: 'Cancelado',
        estados_globales: 1,
      },
      {
        id: 16,
        descripcion: 'Terminado',
        estados_globales: 1,
      },
    ];

    const result1 = await API.post('recaudacion/actuaciones-pae/', ACTUACIONES_PAE[0]);
    const result2 = await API.post('recaudacion/actuaciones-pae/', ACTUACIONES_PAE[1]);
    const result3 = await API.post('recaudacion/actuaciones-pae/', ACTUACIONES_PAE[2]);
    const result4 = await API.post('recaudacion/actuaciones-pae/', ACTUACIONES_PAE[3]);
    const result5 = await API.post('recaudacion/actuaciones-pae/', ACTUACIONES_PAE[4]);
    const result6 = await API.post('recaudacion/actuaciones-pae/', ACTUACIONES_PAE[5]);
    const result7 = await API.post('recaudacion/actuaciones-pae/', ACTUACIONES_PAE[6]);
    const result8 = await API.post('recaudacion/actuaciones-pae/', ACTUACIONES_PAE[7]);
    const result9 = await API.post('recaudacion/actuaciones-pae/', ACTUACIONES_PAE[8]);
    const result10 = await API.post('recaudacion/actuaciones-pae/', ACTUACIONES_PAE[9]);
    const result11 = await API.post('recaudacion/actuaciones-pae/', ACTUACIONES_PAE[10]);
    const result12 = await API.post('recaudacion/actuaciones-pae/', ACTUACIONES_PAE[11]);
    const result13 = await API.post('recaudacion/actuaciones-pae/', ACTUACIONES_PAE[12]);
    const result14 = await API.post('recaudacion/actuaciones-pae/', ACTUACIONES_PAE[13]);
    const result15 = await API.post('recaudacion/actuaciones-pae/', ACTUACIONES_PAE[14]);
    const result16 = await API.post('recaudacion/actuaciones-pae/', ACTUACIONES_PAE[15]);

    store.dispatch({
      type: SET_ACTUACIONES_PAE,
      payload: ACTUACIONES_PAE,
    });
    return [
      result1.data,
      result2.data,
      result3.data,
      result4.data,
      result5.data,
      result6.data,
      result7.data,
      result8.data,
      result9.data,
      result10.data,
      result11.data,
      result12.data,
      result13.data,
      result14.data,
      result15.data,
      result16.data,
    ];
  } catch (err) {
    onError(err);
    return [];
  }
};

export const getEstadosDelCreditoPae = async () => {
  try {
    const { estadosDeCreditosPae } = store.getState().catalogs;
    if (estadosDeCreditosPae?.length) return estadosDeCreditosPae;

    const response = await API.get('recaudacion/estados-del-credito-pae/');

    store.dispatch({
      type: SET_ESTADOS_DE_CREDITOS_PAE,
      payload: response.data,
    });
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};
